import React from 'react'
import './new_paid_social_dashboard.css'
import { getImgSrc, getPlatformImg } from '../../../../helpers/getImgSrc'
import { SlLocationPin } from "react-icons/sl";
import { BsFlag } from "react-icons/bs";
import PieChart from '../../../../components/client/dashboard/PieChart';
import { FiMessageSquare } from "react-icons/fi";
import { GoTrophy } from "react-icons/go";
import { getPlatformNameOrId } from '../../../../helpers/getPlatformName';
import { useNavigate } from "react-router-dom"
import { useDispatch } from 'react-redux';
import { UPDATE_FILTER_DATA } from "../../../../redux/features/user/filterSlice"



const NewPaidSocialDashboard = (
    { paidSocialAccountStatus,
        topPerformingCampaigns,
        topPerformingPlatforms,
        postReactions

    }
) => {
    //console.log(topPerformingCampaigns)
    const platforms = [
        {
            platform_name: 'facebook',
            platform_icon: 'facebook',
            status: paidSocialAccountStatus?.facebook?.status,
            connection_details: {
                connected_by: paidSocialAccountStatus?.facebook?.account_name,
                last_synced: paidSocialAccountStatus?.facebook?.last_synced,
                created_at:paidSocialAccountStatus?.facebook?.account_details?.created_at
            },
            account_details: paidSocialAccountStatus?.facebook?.account_details,
            platform_id: paidSocialAccountStatus?.facebook?.platform_id
        },
        {
            platform_name: 'instagram',
            platform_icon: 'instagram',
            status: paidSocialAccountStatus?.instagram?.status,
            connection_details: {
                connected_by: paidSocialAccountStatus?.instagram?.account_name,
                last_synced: paidSocialAccountStatus?.instagram?.last_synced,
                created_at:paidSocialAccountStatus?.instagram?.account_details?.created_at
            },
            account_details: paidSocialAccountStatus?.instagram?.account_details,
            platform_id: paidSocialAccountStatus?.instagram?.platform_id
        },
        {
            platform_name: 'linkedin',
            platform_icon: 'linkedin',
            status: paidSocialAccountStatus?.linkedin?.status,
            connection_details: {
                connected_by: paidSocialAccountStatus?.linkedin?.account_name,
                last_synced: paidSocialAccountStatus?.linkedin?.last_synced,
                created_at:paidSocialAccountStatus?.linkedin?.account_details?.created_at
            },
            account_details: paidSocialAccountStatus?.linkedin?.account_details,
            platform_id: paidSocialAccountStatus?.linkedin?.platform_id
        }
    ]
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const audienceByCountry = [
        { countryCode: "US", countryName: "United States", audiencePercentage: 35 },
        { countryCode: "GB", countryName: "United Kingdom", audiencePercentage: 10 },
        { countryCode: "CA", countryName: "Canada", audiencePercentage: 75 },
        { countryCode: "AU", countryName: "Australia", audiencePercentage: 67 },
        { countryCode: "DE", countryName: "Germany", audiencePercentage: 55 },

    ];

    const reactionsMetrics = [
        {

            name: "Like",
            value: postReactions?.likes?.count,
            percentage: postReactions?.likes?.percentage?.toFixed(2) ?? 0,
            backgroundColor: '#f97316'
        },

        {

            name: "Comment",
            value: postReactions?.comments?.count,
            percentage: postReactions?.comments?.percentage.toFixed(2) ?? 0,
            backgroundColor: '#fdba74'
        },
        {

            name: "Share",
            value: postReactions?.shares?.count,
            percentage: postReactions?.shares?.percentage.toFixed(2) ?? 0,
            backgroundColor: '#fb923c'
        },
        {

            name: "Save",
            value: postReactions?.save?.count,
            percentage: postReactions?.save?.percentage.toFixed(2) ?? 0,
            backgroundColor: '#fed7aa'
        }
    ]
    const platforms_list = [
        {
            name: 'facebook',
            platform_icon: 'facebook',
            percentage: 67,
            backgroundColor: '#4267b2'
        },
        {
            name: 'instagram',
            platform_icon: 'instagram',
            percentage: 27,
            backgroundColor: '#c13584'
        },
        {
            name: 'linkedin',
            platform_icon: 'linkedin',
            percentage: 47,
            backgroundColor: '#0077b5'
        }
    ]
    // values,labels,backgroundColors

    const values = [

        postReactions?.likes?.count,
        postReactions?.shares?.count,
        postReactions?.comments?.count,
        postReactions?.save?.count
    ]
    const labels = ['Like', 'Share', 'Comment', 'Save']
    const backgroundColors = ['#f97316', '#fb923c', '#fdba74', '#fed7aa']

    const handlePlatformFilter = (platform) => {
        try {
        
            dispatch(UPDATE_FILTER_DATA(
                { filter_ads_selected_platform: { platform_id: platform?.platform_id, social_media_type: 'paid_social', account_details: platform?.account_details } }
            ))
            navigate('/client/settings/link-ads')

        } catch (e) {
            console.log(e)
        }
    }





    return (
        <div className='paid_social_main'>
            <section className='paid_social_connected_accounts_section'>
                <div className="paid_social_connected_accounts_wrapper">
                    <div className="paid_social_connected_accounts_wrapper_border">

                    </div>
                    <div className="paid_social_connected_accounts_wrapper_top">
                        <div className='paid_social_connected_accounts_wrapper_top_heading' >
                            <div className='paid_social_connected_accounts_wrapper_top_logo' >
                                <img src={getImgSrc('refresh')} alt="" />
                            </div>
                            <div className='paid_social_connected_accounts_wrapper_top_heading_text'>
                                <h3 className=''>Connected Accounts</h3>
                                <span></span>
                            </div>


                        </div>

                    </div>
                    <div className="paid_social_connected_accounts_wrapper_bottom">
                        {platforms?.map((platform) => {
                            return <div className="platform_card">
                                <div className="top">
                                    <div className='heading'>
                                        <div className='logo'>
                                            <img src={getImgSrc(platform?.platform_icon)} alt="" />
                                        </div>
                                        <h4>{platform?.platform_name}</h4>


                                    </div>
                                    <div className='status'>
                                        <div className={` ${platform?.status === "Completed" ? 'completed' : 'pending'} status_badge`}>
                                            <span>{platform?.status}</span>
                                        </div>
                                        <div style={{ cursor: 'pointer' }} className="settings_icon" onClick={() => handlePlatformFilter(platform)}>
                                            <img src={getImgSrc('settings')} alt="" />
                                        </div>

                                    </div>

                                </div>
                                {/* <div className="main_details">
                                    <p className='page_name'></p>
                                    <div className='sync_details'>
                                        <span></span>
                                        <span></span>
                                        <span>Last Synced:{platform?.connection_details?.last_synced}</span>
                                    </div>

                                </div> */}
                                <div className="bottom">
                                    <div className="user_connected_details">
                                        <div className='user_connected_details_container'>
                                            <span>Account Name :</span>
                                            <span>{platform?.connection_details?.connected_by || "---"}</span>
                                        </div>
                                        <div className='user_connected_details_container'>
                                            <span>Last Synced :</span>
                                            <span>{platform?.connection_details?.last_synced || "---"}</span>
                                        </div>
                                        <div className='user_connected_details_container'>
                                            <span>Connected On :</span>
                                            <span>{platform?.connection_details?.created_at || "---"}</span>
                                        </div>

                                    </div>


                                </div>

                            </div>
                        })}


                    </div>

                </div>

            </section>
            {/* top performing campiagns by platform */}
            <section className='top_performing_campaigns_section'>

                <div className="paid_social_connected_accounts_wrapper ">
                    <div className="paid_social_connected_accounts_wrapper_border" style={{ backgroundColor: '#9334ea' }}>

                    </div>
                    <div className="paid_social_connected_accounts_wrapper_top">
                        <div className='paid_social_connected_accounts_wrapper_top_heading' >
                            <div className='paid_social_connected_accounts_wrapper_top_logo' style={{ backgroundColor: '#f3e8ff' }}>
                                <img src={getImgSrc('trophy')} alt="" />
                            </div>
                            <div className='paid_social_connected_accounts_wrapper_top_heading_text'>
                                <h3 className=''>Top Performing Campaigns by Platform</h3>
                                <span></span>
                            </div>


                        </div>

                    </div>
                    <div className="paid_social_connected_accounts_wrapper_bottom">

                        {topPerformingCampaigns?.map((platform) => {
                            return <div className="top_performing_campaign_card">
                                <div className='top_performing_campaign_card_top'>
                                    <div className='top_performing_campaign_card_top_heading'>
                                        <div className='top_performing_campaign_card_top_heading_logo'>
                                            <img src={getPlatformImg(platform?.platform_id)} alt="" />
                                        </div>
                                        <h3>{getPlatformNameOrId(platform?.platform_id)}</h3>

                                    </div>
                                    <div className='top_performing_campaign_card_top_badge'>
                                        <span>{platform?.campaign_name != "" ? platform?.campaign_name : '---'}</span>
                                    </div>

                                </div>
                                <div className='top_performing_campaign_card_bottom'>
                                    {platform?.metrics?.length > 0 && platform?.metrics
                                        .filter(metric => {
                                            const name = metric?.name?.toLowerCase().replace(/_/g, ' ');
                                            return ['clicks', 'impressions', 'spend', 'other engagements'].includes(name);
                                        })
                                        .map(metric => {
                                            return (
                                                <div className='top_performing_campaign_card_bottom_metric' key={metric?.name}>
                                                    <span>{metric?.name
                                                        ?.replace(/_/g, ' ')
                                                        .replace(/\b\w/g, char => char.toUpperCase())}</span>
                                                    <span> {Number(String(metric?.value).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</span>
                                                </div>
                                            );
                                        })}


                                </div>

                            </div>


                        })}



                    </div>

                </div>


            </section >
            {/* geographical locations and post reactions */}

            <section className='geographical_location_and_post_reaction d-none'>
                <div className='geographical_location_section'>
                    <div className="paid_social_connected_accounts_wrapper ">
                        <div className="paid_social_connected_accounts_wrapper_border" style={{ backgroundColor: '#16a34a' }}>

                        </div>
                        <div className="paid_social_connected_accounts_wrapper_top">
                            <div className='paid_social_connected_accounts_wrapper_top_heading' >
                                <div className='paid_social_connected_accounts_wrapper_top_logo' style={{ backgroundColor: '#dcfce7' }}>
                                    <img src={getImgSrc('earth')} alt="" />
                                </div>
                                <div className='paid_social_connected_accounts_wrapper_top_heading_text'>
                                    <h3 className=''>Geographical Locations</h3>
                                    <span></span>
                                </div>


                            </div>

                        </div>
                        <div className="paid_social_connected_accounts_wrapper_bottom geographical_locations">
                            <div className='paid_social_connected_accounts_wrapper_bottom_locations_container'>
                                {audienceByCountry?.map((country, index) => {
                                    return <div className='paid_social_connected_accounts_wrapper_bottom_location' style={{ background: index % 2 == 0 ? '#f3fdf6' : '' }}>
                                        <div className='paid_social_connected_accounts_wrapper_bottom_location_top'>
                                            <div className='paid_social_connected_accounts_wrapper_bottom_location_country_code'>
                                                <span>{country?.countryCode}</span>
                                            </div>
                                            <div className='paid_social_connected_accounts_wrapper_bottom_location_country_details'>
                                                <p>{country?.countryName}</p>
                                                <div>
                                                    <SlLocationPin className='location_pin_icon' />
                                                    <span>{country?.audiencePercentage}% of audience</span>
                                                </div>
                                            </div>

                                        </div>
                                        <div className='paid_social_connected_accounts_wrapper_bottom_location_bottom'>
                                            <div className='paid_social_connected_accounts_wrapper_bottom_location_bottom_progress_bar'>
                                                <div className="progress">
                                                    <div className="progress-bar" role="progressbar" style={{ width: country?.audiencePercentage + '%' }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                                <div className='paid_social_connected_accounts_wrapper_bottom_location_bottom_progress_bar_percentage'>
                                                    <span>{country?.audiencePercentage}%</span>
                                                </div>

                                            </div>

                                        </div>

                                    </div>


                                })}


                            </div>

                            <div className='bottom_footer_hedaing'>
                                <div className='text_content'>
                                    <BsFlag />
                                    <span>Data represents user distribution by country</span>
                                </div>
                                <div className='button'>
                                    {/* <button>View All Accounts</button> */}
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <div className='post_reaction_section'>
                    <div className="paid_social_connected_accounts_wrapper ">
                        <div className="paid_social_connected_accounts_wrapper_border" style={{ backgroundColor: '#ea580c' }}>

                        </div>
                        <div className="paid_social_connected_accounts_wrapper_top">
                            <div className='paid_social_connected_accounts_wrapper_top_heading' >
                                <div className='paid_social_connected_accounts_wrapper_top_logo' >
                                    <img src={getImgSrc('trophy')} alt="" />
                                </div>
                                <div className='paid_social_connected_accounts_wrapper_top_heading_text'>
                                    <h3 className=''>Post Reactions</h3>
                                    <span></span>
                                </div>


                            </div>

                        </div>
                        <div className="paid_social_connected_accounts_wrapper_bottom">

                            <div className='paid_social_connected_accounts_wrapper_bottom_reactions_container'>
                                <div className='paid_social_connected_accounts_wrapper_bottom_reactions_top'>
                                    <div className='paid_social_connected_accounts_wrapper_bottom_reactions_top_chart'>
                                        <PieChart values={values} labels={labels} backgroundColors={backgroundColors} />
                                    </div>

                                </div>
                                <div className='paid_social_connected_accounts_wrapper_bottom_reactions_bottom'>
                                    <div className='paid_social_connected_accounts_wrapper_bottom_reactions_bottom_container'>
                                        <div className='paid_social_connected_accounts_wrapper_bottom_reactions_bottom_container_heading'>
                                            <FiMessageSquare />
                                            <h4>Reactions Container</h4>
                                        </div>
                                        <div className='paid_social_connected_accounts_wrapper_bottom_reactions_bottom_container_items_list'>
                                            {reactionsMetrics?.map((post) => {
                                                return <div className='post_reaction_item'>
                                                    <div className='post_reaction_item_top'>
                                                        <div className='post_reaction_header'>
                                                            <div className='post_reaction_item_dot'></div>
                                                            <span>{post?.name}</span>
                                                        </div>
                                                        <span>{post?.value}</span>
                                                    </div>
                                                    {/* progress bar */}
                                                    <div className="progress">
                                                        <div className="progress-bar" style={{ width: post?.percentage + '%', backgroundColor: post?.backgroundColor ? post?.backgroundColor : '#f97316' }}></div>
                                                    </div>
                                                    <div className='post_reaction_item_bottom'>
                                                        <span>{post?.percentage}%</span>
                                                    </div>

                                                </div>
                                            })}




                                        </div>

                                    </div>

                                </div>

                            </div>




                        </div>

                    </div>
                </div>

            </section>

            {/* most productive platform section */}
            <section className='most_productive_platform_section'>
                <div className="paid_social_connected_accounts_wrapper ">
                    <div className="paid_social_connected_accounts_wrapper_border" style={{ backgroundColor: '#0d9488' }}>

                    </div>
                    <div className="paid_social_connected_accounts_wrapper_top">
                        <div className='paid_social_connected_accounts_wrapper_top_heading' >
                            <div className='paid_social_connected_accounts_wrapper_top_logo' >
                                <img src={getImgSrc('trophy')} alt="" />
                            </div>
                            <div className='paid_social_connected_accounts_wrapper_top_heading_text'>
                                <h3 className=''>Most Productive Platform</h3>
                                <span></span>
                            </div>


                        </div>

                    </div>
                    <div className="paid_social_connected_accounts_wrapper_bottom ">

                        <div className='paid_social_connected_accounts_wrapper_bottom_productive_platform_container'>
                            <div className='paid_social_connected_accounts_wrapper_bottom_productive_platform_container_top'>
                                <div className='top_performer_details_container'>
                                    <div className='productive_platform_logo_container'>
                                        <div className='productive_platform_logo'>
                                            <img src={topPerformingPlatforms?.platform_id ? getPlatformImg(topPerformingPlatforms?.platform_id) : ''} alt="" />

                                        </div>
                                    </div>
                                    <div className='productive_platform_content_container'>
                                        <h4>{getPlatformNameOrId(topPerformingPlatforms?.platform_id)}</h4>
                                        <div className='top_performer_badge'>
                                            <GoTrophy />
                                            <span>Top Performer</span>
                                        </div>
                                    </div>


                                </div>


                            </div>

                            <div className='paid_social_connected_accounts_wrapper_bottom_productive_platform_container_bottom'>
                                <div className="productive_platform_productivity_score_top">
                                    <div className='productive_platform_productivity_score_top_container'>
                                        <div className='productive_platform_productivity_score_top_container_heading'>

                                            <h4>Productivity Score</h4>
                                            <div className='productive_platform_productivity_score_top_container_heading_score_container'>
                                                <div className='productive_platform_productivity_score_top_container_heading_logo'>
                                                    <img src={topPerformingPlatforms?.platform_id ? getPlatformImg(topPerformingPlatforms?.platform_id) : ''} alt="" />
                                                </div>
                                                <span>{topPerformingPlatforms?.percentage?.toFixed(2)}/100</span>
                                            </div>

                                        </div>
                                        {/* progress bar */}
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" style={{ width: topPerformingPlatforms?.percentage?.toFixed(2) + '%' }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{topPerformingPlatforms?.percentage?.toFixed(2)}</div>
                                        </div>

                                    </div>

                                </div>
                                <div className="productive_platform_productivity_score_bottom">
                                    <p>All Platform Productivity Score</p>
                                    <hr />
                                    {topPerformingPlatforms?.other_platforms?.map((platform) => {
                                        return <div className="platform_productivity_score_card">
                                            <div className='platform_productivity_score_card_heading'>
                                                <div className="productivity_score_card_logo">
                                                    <img src={platform?.platform_id ? getPlatformImg(platform?.platform_id) : ''} alt="" />
                                                </div>
                                                <span>{getPlatformNameOrId(platform?.platform_id)}</span>

                                            </div>
                                            <div className='platform_productivity_score_card_scores'>
                                                <div className="progress">
                                                    <div className="progress-bar" role="progressbar" style={{ width: `${platform?.percentage}%`, backgroundColor: platform?.backgroundColor }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                                {/* metrics */}
                                                <span>{platform?.percentage ? platform?.percentage?.toFixed(2) : 0}/100</span>

                                            </div>

                                        </div>
                                    })}


                                    <div>
                                        <p>Best Performing Platform in Terms of Clicks</p>
                                    </div>

                                </div>

                            </div>

                        </div>


                    </div>

                </div>

            </section>

        </div>
    )
}

export default NewPaidSocialDashboard